module.exports = __webpack_public_path__ + "static/191203-BS-IGB-F1-Destroyer-3rd-Spec-Preview-49f6f854f72ff8c7bf8ec5182e04ba04.jpg";